import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule, Router, NavigationEnd, ActivatedRoute, Data } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TablerIconsModule } from 'angular-tabler-icons';

import { NavDataService } from 'src/app/services/nav-data.service'; // 1. Importa el servicio
import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule, NgIf, TablerIconsModule],
  templateUrl: './breadcrumb.component.html'  
})
export class AppBreadcrumbComponent {
  pageInfo: Data | any = Object.create(null);
  // 2. A�ade una propiedad para guardar el �cono
  pageIcon: string | null = null; 

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private navDataService: NavDataService // 2. Inyecta el servicio
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) { route = route.firstChild; }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      .subscribe((event) => {
        this.titleService.setTitle(event['title'] + ' - GRUMAN');
        this.pageInfo = event;
        
        // 3. Obtiene la lista actual de items DESDE EL SERVICIO
        const currentNavItems = this.navDataService.getCurrentNavItems();
        const currentRoute = this.router.url.substring(1);
        const activeNavItem = this.findNavItemByRoute(currentNavItems, currentRoute);
        
        if (activeNavItem) {
          this.pageIcon = activeNavItem.iconName ?? null;
        } else {
          this.pageIcon = 'point';
        }
      });
  }

  // 4. A�ade la funci�n de b�squeda recursiva
  private findNavItemByRoute(items: NavItem[], route: string): NavItem | null {
    for (const item of items) {
      if (item.route === route) {
        return item;
      }
      if (item.children && item.children.length > 0) {
        const foundInChildren = this.findNavItemByRoute(item.children, route);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }    
    // Si despu�s de recorrer todos los items no se encontr� nada, retorna null
    return null;
  }

}